export const FreezeContractsPage = (destinationLang) => {
  return [
    {
      FormKey: "main-menu-drawer-link-freeze-contract",
      Key: "قرارداد های انجماد",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "freeze-contracts-label-freeze-type",
      Key: "نوع فریز",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "freeze-contracts-label-contract-start-date",
      Key: "تاریخ شروع قرار داد",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "freeze-contracts-label-contract-end-date",
      Key: "تاریخ پایان قرار داد",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "freeze-contracts-label-contract-range",
      Key: "بازه قرار داد",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "freeze-contracts-label-owe-price",
      Key: "مبلغ بدهکاری",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "freeze-contracts-btn-upload-bank-receipt",
      Key: "بارگذاری رسید",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "freeze-contracts-btn-get-receipt-list",
      Key: "لیست رسید",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "freeze-contracts-label-price",
      Key: "مبلغ",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "freeze-contracts-label-get-contract-list",
      Key: "قرارداد ها",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "freeze-contracts-label-get-receipt-list",
      Key: "فیش ها",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "freeze-contracts-label-charge-contract",
      Key: "تمدید قرارداد انجماد",
      DistinitationLanguage: destinationLang,
    },
  ];
};
